import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("epc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Kuchh gadbad ho gayi. Please try again.";
}

export function saveAuth(token, user) {
  localStorage.setItem("epc_token", token);
  localStorage.setItem("epc_user", JSON.stringify(user));
}

export function clearAuth() {
  localStorage.removeItem("epc_token");
  localStorage.removeItem("epc_user");
}

export function loadUser() {
  try {
    return JSON.parse(localStorage.getItem("epc_user") || "null");
  } catch {
    return null;
  }
}
